export function Schema() {
  return {
    category: 'Legal',
    label: 'Pandectes Withdrawal',
    key: 'pandectes-withdrawal',
    fields: [
      {
        label: 'Locale',
        name: 'localeCode',
        component: 'text',
        description: 'Two-letter locale code (e.g. "en"). Required.',
        defaultValue: 'en',
      },
      {
        label: 'Language',
        name: 'lang',
        component: 'text',
        description: 'Language code (e.g. "en"). Required.',
        defaultValue: 'en',
      },
    ],
  };
}
